import script from "./EditRole.vue?vue&type=script&setup=true&lang=js"
export * from "./EditRole.vue?vue&type=script&setup=true&lang=js"

import "./EditRole.vue?vue&type=style&index=0&id=37087366&lang=css"

const __exports__ = script;

export default __exports__